import React, {
  useMemo,
  useContext,
  useEffect,
  useState,
} from 'react'
import { OverlaySearchContext as OverlaySearchProviderProxy } from '@usap/widgets'

import localConfig from '../../config/local-config'

import {
  useVehicleImageContext,
  getOverlayImageLink,
  getFront,
  VEHICLE_IMAGE,
  isOverlayed,
} from './vehicleImage.context'

import { LocalContext } from '../helpers/useLocalContext'

/**
 * Overlay Image Provide (SERP)
 *
 * @param   {JSX.Element} param   Children
 * @return  {JSX.Element}
 */
export default function OverlaySearchProvider({
  overlayItems,
  children,
}) {
  const [overlayDetails, setOverlayDetails] = useState({})
  const [uniqueParts, setUniqueParts] = useState([])
  const { images } = useVehicleImageContext()
  const { localContext } = useContext(LocalContext)
  const { isDesktop } = localContext

  const overlayContextValue = useMemo(
    () => overlayDetails,
    [overlayDetails],
  )

  useEffect(() => {
    const parts = {}
    const vehicleId = getFront(images, VEHICLE_IMAGE.publicId)

    overlayItems.forEach(item => {
      const haveOverlay = uniqueParts[item.part] &&
        vehicleId &&
        (item.isUniversal || item.fitNotes.length)

      parts[item.id] = haveOverlay
        ? getOverlayImageLink(
          item.productImageUrl,
          vehicleId,
          isDesktop ? 120 : 100,
        )
        : item.productImageUrl
    })

    setOverlayDetails(parts)
  }, [isDesktop, overlayItems, uniqueParts, images])

  useEffect(() => {
    const _uniqueParts = [...new Set(overlayItems.map(x => x.part))]
    const _uniqueBrands = [...new Set(overlayItems.map(x => x.brand))]
    setOverlayDetails({})

    const updateParts = async part => {
      const partEnabled = await isOverlayed(part, _uniqueBrands)

      // eslint-disable-next-line security/detect-object-injection
      if (!uniqueParts[part]) {
        setUniqueParts(prev => ({
          ...prev,
          [part]: partEnabled,
        }))
      }
    }

    _uniqueParts.forEach(part => {
      if (localConfig.overlayRollupDisplay) {
        updateParts(part)
      }
    })
  }, [overlayItems, uniqueParts])

  return (
    <OverlaySearchProviderProxy.Provider value={overlayContextValue}>
      {children}
    </OverlaySearchProviderProxy.Provider>
  )
}
